export const isDevelopment = process.env.GATSBY_ENV === 'development'
